import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { FilterInput } from '@it2go/data-grid';
import { WorkGridItemObject } from '@it2go/types';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { Operator } from '../../../../../../../../../data-grid/src/grid/grid-request.dto';
import { UserChipComponent } from '../../../../../../components/kit/user-chip/user-chip.component';
import { UserChipRenderTypeEnum } from '../../../../../../components/kit/user-chip/user-chip.component.types';
import { workUri } from '../../../../../../utils/router.utils';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { dateField, longTextField, serviceField } from '../../../../../shared/components/kit/table/table.fields';
import { TableColumn } from '../../../../../shared/components/kit/table/table.types';
import { operationalReportsFragment } from './operational-reports-widget.query';
import { OperationalReportsWidgetStore } from './operational-reports-widget.store';

@Component({
    selector: 'app-operational-reports-widget',
    templateUrl: './operational-reports-widget.component.html',
    providers: [OperationalReportsWidgetStore],
    imports: [
        TableComponent,
        PrimeTemplate,
        TranslatePipe,
        UserChipComponent,
    ],
})
export class OperationalReportsWidgetComponent {
    protected readonly store = inject(OperationalReportsWidgetStore);
    private readonly router = inject(Router);

    protected readonly prefix = 'dashboard.operationalReports.';
    protected readonly UserChipRenderTypeEnum = UserChipRenderTypeEnum;

    public readonly items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected readonly additionalFilter = computed<FilterInput[][]>(() => [
        [{
            column: 'serviceId',
            operator: Operator.IN,
            value: this.items().map(item => item.serviceId),
        }],
        [{
            column: 'workType',
            operator: Operator.EQ,
            value: [WorkTypeEnum.OPERATIONAL_REPORT],
        }],
    ]);

    protected readonly columns = computed<TableColumn[]>(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            {
                name: 'clients',
                dataKey: 'workData.folders',
                sortable: false,
                filterable: false,
            },
            dateField('dateFrom', false),
            {
                name: 'type',
                dataKey: 'workData.type',
                sortable: false,
                filterable: false,
            },
            {
                ...longTextField('description', false, false),
                dataKey: 'workData.description',
            },
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected async detail(item: WorkGridItemObject): Promise<void> {
        if (item.serviceId == null) return;

        await this.router.navigateByUrl(workUri({
            workType: WorkTypeEnum.OPERATIONAL_REPORT,
            id: item.id,
        }, item.serviceId));
    }

    protected readonly fragment = operationalReportsFragment;
}
